import DOMPurify from 'dompurify';
/**
 * Renders the feed based on the provided data.
 * @param {Object} feed - The feed data to be rendered.
 */
export default function renderFeed(feed) {
	// Some language codes are 2 characters, some are more. This is to get the first 2 characters of the language code.
	const currentLangCode = document
		.querySelector('html')
		.getAttribute('lang')
		.slice(0, 2);
	if (feed !== undefined && feed.total_pages !== undefined) {
		let html = ''; // The HTML to be rendered.

		// If there are no posts, display a message.
		if (feed.posts.length === 0) {
			let keywords = ``;
			if (
				global.filters.search !== undefined &&
				global.filters.search !== ''
			) {
				keywords += ` for "${global.filters.search}"`;
			}

			html += `<div role="status"><h3 class="govuk-heading-m text-center mt-4">Showing 0 results${keywords}</h3>
<div class="flex  items-stretch items-center justify-center">
      <div class="border-2 border-gsg-grey p-6 self-center">
        <p class="govuk-body-s">There are no matching results.</p>
        <p class="govuk-body-s">Improve your search results by:</p>
    
        <ul class="govuk-list govuk-list--bullet mt-2">
          <li class="govuk-body-s">Removing filters</li>
          <li class="govuk-body-s">Double-checking your spelling</li>
          <li class="govuk-body-s">Using fewer keywords</li>
          <li class="govuk-body-s">Searching for something less specific</li>
        </ul>
      </div></div></div>`;
		} else {
			// We have posts to display.
			for (let i = 0; i < feed.posts.length; i++) {
				const item = feed.posts[i];
				const content = DOMPurify.sanitize(item.post_content);

				// Deal with the featured image.
				let image = '';
				if (
					item.featured_image !== undefined &&
					item.featured_image !== ''
				) {
					image = `<div class="col-span-9 md:col-span-3 pb-6 md:pb-0 md:pr-6"><img src="${item.featured_image}" alt="" class="mb-4 object-cover w-full h-full" loading="lazy"></div>`; //No alt for accessibility as it is decorative
				}

				// If the current language is English, use the pretty URL. Otherwise, use the parsed URL.
				const parsedUrl = new URL(item.pretty_url);
				parsedUrl.pathname = `/${currentLangCode}${parsedUrl.pathname}`;
				const postUrl =
					currentLangCode === 'en' ? item.pretty_url : parsedUrl;

				// Function: Capitalise the first letter of the post type
				const capitalise = (string) => {
					let newString = string.replace(/-/g, ' ');
					newString =
						newString.charAt(0).toUpperCase() + newString.slice(1);
					return newString;
				};

				let postDate = '';
				if (item.post_date !== undefined && item.post_date !== '') {
					// Deal with any end dates for events.
					let endDate = '';
					if (
						item.post_end_date !== undefined &&
						item.post_end_date !== ''
					) {
						endDate = ` - ${item.post_end_date}`;
					}
					postDate = DOMPurify.sanitize(
						`<p class="govuk-body-sm">${item.post_date}${endDate}</p>`
					);
				}

				// Build the HTML.
				html += `<div class="my-6 p-5 grid grid-cols-9 bg-white shadow">
					${image}
					<div class="col-span-9 ${image === '' ? 'md:col-span-9' : 'md:col-span-6'}">
					<span class="govuk-body-s block mb-0">${DOMPurify.sanitize(capitalise(item.post_type))}</span>
                      <h2 class="govuk-heading-m pt-2"><a href="${postUrl}" class="govuk-link">${DOMPurify.sanitize(
							item.post_title
						)}</a></h2>
						${postDate}
                      <p class="govuk-body my-3">${content}</p>  
					  </div>
                  </div>`;
			}
		}

		document.querySelector('.js-gsfc-feed').innerHTML = html;
	}
}
